import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ } from "@/data/content";
import { Reveal } from "./Reveal";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="mx-auto max-w-[1360px] px-5 pb-14 lg:px-10">
    <div className="grid gap-8 lg:grid-cols-[320px_1fr]">
      <Reveal>
        <h2 className="font-display text-[28px] font-bold tracking-tight text-[#0B1B33]">Honest answers</h2>
        <p className="mt-2 text-[15px] text-slate-600">Practical, patient and technically credible. No hype.</p>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="rounded-2xl border border-slate-200 bg-white px-6">
          {FAQ.map((f, i) => (
            <AccordionItem key={f.q} value={`f${i}`} className={i === FAQ.length - 1 ? "border-b-0" : ""}>
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="font-display text-left text-[16px] font-semibold text-[#0B1B33] hover:no-underline">{f.q}</AccordionTrigger>
              <AccordionContent className="text-[15px] leading-relaxed text-slate-700">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
